import { numBox } from "../rendering/controls-templates-brewed.js";
import { Editor } from "./Editor.js";
import { default as numeral } from "numeral";

export class NumBox extends Editor {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            format = (options && options.format) || '0',
            autofocus = (options && options.autofocus) || false,
        } = options;

        this.format = format;
        this.autofocus = autofocus;
    }

    initialize(parent, params) {

        control.initialize.call(this, parent, params);
        this.format = (params && params.format) || '0';
        this.autofocus = (params && params.autofocus) || false;
        return this;

    };

    formatValue(value) {

        return numeral(value).format(this.format);

    };

    parseValue(text) {

        return numeral(text).value();

    };

    isAutofocus() {

        return (typeof this.autofocus === 'function') ? this.autofocus.call(this) : this.autofocus;

    };

    getFormat() {

        return (typeof this.format == 'function') ? this.format.call(this) : this.format;

    };

    _render(vm) {

        var that = this,
            value = this.getValue(),
            format = this.getFormat(),
            style = this.getCss(),
            props = Object.assign({
                id: this.getId(),
                value: this.getValue(),
                onchange: onValueChange,
                readonly: (this.isReadOnly() || this.isDisabled()) && 'readonly',
                'data-focus': !(this.isDisabled() || this.isReadOnly()) && this.isAutofocus() ? 'auto' : null,
            }),
            params = {
                visible: this.isVisible(),
            },
            oldParsedValue = '';

        if (this.immediateValueChange) {
            //props.onkeydown = onValuePossibleChange;
            props.onkeyup = onValuePossibleChange;
        }

        return numBox(value, format, style, props, params);

        function onValueChange(e, node) {
            var value = e.target.value,
                parsedValue = that.parseValue(value);
            that.changeValue(parsedValue);
        };

        function onValuePossibleChange(e, node) {
            var value = e.target.value,
                parsedValue = that.parseValue(value);
            if (parsedValue == oldParsedValue)
                return;
            oldParsedValue = parsedValue;
            that.changeValue(parsedValue);
        };

    };

}